import { Route, Switch, useLocation } from 'react-router';

import PropTypes from 'prop-types';

import EventDetailsContainer from '../containers/EventDetailsContainer';
import EventRsvpsContainer from '../containers/EventRsvpsContainer';

import SecondLineTabs from '../../Tabs/SecondLineTabs';

const EventDetailsRouter = ({ match }) => {
  const { url, path } = match;
  const location = useLocation();

  const secondLineTabs = [
    {
      label: 'Details',
      url: `${url}/lists`,
    },
    {
      label: 'Manage RSVP`s',
      url: `${url}/rsvps`,
    },
  ];

  return (
    <>
      <SecondLineTabs currentUrl={location.pathname} tabData={secondLineTabs} />
      <Switch>
        <Route path={`${path}/lists/`} component={EventDetailsContainer} />
        <Route path={`${path}/rsvps/`} component={EventRsvpsContainer} />
      </Switch>
    </>
  );
};

EventDetailsRouter.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default EventDetailsRouter;
